import { useNavigate } from "react-router-dom";
import RolesListTopbar from "../../features/manageSubAdmin/rolesTopbar";
import RolesList from "../../features/manageSubAdmin/rolesList";
import { useEffect, useState, useCallback } from "react";
import {
  useDeleteRoleMutation,
  useLazyGetRoleQuery,
} from "../../services/role";
import { Role } from "../../types/General";
import { showError, showToast } from "../../constants/toasts";
import DeleteConfirmModal from "../../Modals/deleteConfirmModal";

const ManageSubadminRoles = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [getRole] = useLazyGetRoleQuery();
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<Role[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [deleteRole] = useDeleteRoleMutation();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteId, setDeleteId] = useState<number>(0);

  const getRoleList = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getRole({
        length: 10,
        start: page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response.status === 200) {
        setData(response.data || []);
        setTotalCount(response.recordsTotal || 0);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  }, [getRole, page, debouncedSearchTerm]);

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await deleteRole({ id: deleteId }).unwrap();
      showToast("Role Deleted Successfully");
      getRoleList();
    } catch (error: any) {
      showError(error?.data?.message || "Failed to delete role");
    }
    setDeleteOpen(false);
    setDeleteId(0);
  };

  const openDeleteModal = (id: number) => {
    setDeleteId(id);
    setDeleteOpen(true);
  };

  useEffect(() => {
    getRoleList();
  }, [getRoleList]);

  return (
    <>
      <div className="main_title">
        <h1>Manage Roles</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
          <span onClick={() => navigate("/manage-subadmin")}>
            Manage Sub-Admin
          </span>{" "}
          - Manage Roles
        </p>
      </div>

      <div className="cards">
        <RolesListTopbar
          setPage={setPage}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
        <RolesList
          data={data}
          isLoading={isLoading}
          totalCount={totalCount}
          page={page}
          setPage={setPage}
          onSearch={setDebouncedSearchTerm}
          onDelete={openDeleteModal}
        />
        <DeleteConfirmModal
          open={deleteOpen}
          setOpen={setDeleteOpen}
          handleDelete={handleDelete}
          title="Are you sure you want to delete this Role?"
          message="This action cannot be undone."
        />
      </div>
    </>
  );
};

export default ManageSubadminRoles;
